var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatisticsArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66382 0.046875C6.47495 0.046875 6.38037 0.275221 6.51392 0.408768L6.97305 0.867898C7.05584 0.950686 7.05584 1.08491 6.97305 1.1677L5.20381 2.93694C5.12102 3.01973 4.98679 3.01973 4.904 2.93694L3.50797 1.54091C3.42514 1.45808 3.29084 1.45812 3.20807 1.54101L0.365945 4.38697C0.283252 4.46977 0.283297 4.60392 0.366046 4.68667L0.664163 4.98478C0.746951 5.06757 0.881177 5.06757 0.963965 4.98478L3.20807 2.74068C3.29086 2.65789 3.42508 2.65789 3.50787 2.74068L4.90412 4.13693C4.98687 4.21968 5.121 4.21973 5.20381 4.13705L7.5751 1.76952C7.65791 1.68684 7.79205 1.6869 7.87479 1.76964L8.33403 2.22889C8.46758 2.36243 8.69593 2.26785 8.69593 2.07899V0.258867C8.69593 0.141787 8.60102 0.046875 8.48394 0.046875H6.66382Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsArrowUp);
export default __webpack_public_path__ + "static/media/statistics-arrow-up.65e0cfc55cf060cd66e4a3b611f409a1.svg";
export { ForwardRef as ReactComponent };